import React, { useEffect, useState, useRef } from 'react';
import OfficePolicyCard from '../../../components/cards/PolicyCard';
import { getPolicies } from '../../../services/policyAPIs';
import {
  TextField,
} from '@mui/material';
import {generateWordDoc} from '../../../utils/downloadHelpers';
import {generatePDF} from '../../../utils/pdfGenerator';

// ==============================|| HR HANDBOOK PAGE ||============================== //

// Default keywords
//const defaultFilters = ['Offboarding', 'Onboarding'];
const defaultFilters = [];

const HRHandbookPage = () => {

  const chartRefs = useRef({});

  const downloadRef = React.useRef(null);

  const [policies, setPolicies] = useState([]);
  const [filters, setFilters] = useState(defaultFilters);
  const [newFilter, setNewFilter] = useState('');
  const [title, setTitle] = useState('HR Handbook');
  const [downloadFormat, setDownloadFormat] = useState('pdf');
  const [allExpanded, setAllExpanded] = useState(false);
  const up= "hr";

  

  useEffect(() => {
    const fetchPolicies = async () => {
      try {
        const data = await getPolicies();
        setPolicies(data);
      } catch (error) {
        console.error('Failed to fetch policies', error);
      }
    };

    fetchPolicies();
  }, []);


  //Download
  // const handleDownload = async () => {
  //   if (!Array.isArray(filteredPolicies)) {
  //     console.error("filteredPolicies is not an array");
  //     return;
  //   }
  
  //   if (downloadFormat === 'pdf') {
  //     await generatePDF(title, filteredPolicies,  chartRefs.current);
  //   } else {
  //     await generateWordDoc(title, filteredPolicies);
  //   }
  // };


  const handleDelete = (id) => {
    setPolicies(policies.filter(policy => policy.id !== id));
  };

  //Filtring
  const handleAddFilter = () => {
    const trimmed = newFilter.trim();
    if (trimmed && !filters.includes(trimmed)) {
      setFilters((prev) => [...prev, trimmed]);
      setNewFilter('');
    }
  };
  const handleRemoveFilter = (keyword) => {
    setFilters((prev) => prev.filter((f) => f !== keyword));
  };

  const filteredPolicies = filters.length === 0
  ? policies
  : policies.filter((policy) =>
      filters.some((keyword) =>
        policy.title.toLowerCase().includes(keyword.toLowerCase()) ||
        policy.body.toLowerCase().includes(keyword.toLowerCase())
      )
  );
  const handleFilterClick = (keyword) => {
  setFilters([keyword]);
  };

  const handleDownload = async () => {
  if (!Array.isArray(filteredPolicies)) {
    console.error("filteredPolicies is not an array");
    return;
  }

};


  return (
    <div>
            <div style={{ marginBottom: '1rem', marginTop: '0.5rem',display: 'flex', flexDirection: 'row', gap:'10px'}}>
              <h3>Active Filters:</h3>
              {filters.map((filter) => (
              <div key={filter} style={{ position:'relative', gap:'15px'}}>
                <button
                  onClick={() => handleFilterClick(filter)}
                  style={{
                    // margin: '4px',
                    padding: '6px 12px',
                    backgroundColor: '#eee',
                    border: '1px solid #ccc',
                    borderRadius: '12px',
                    cursor: 'pointer'
                  }}
                >
                  {filter} 
                </button>
                <button
                  
                  onClick={() => handleRemoveFilter(filter)}
                  style={{
                    position:'absolute',
                    top:'35%',
                    left:'85%',
                    cursor: 'pointer',
                    background:'transparent',
                    border:'none'
                  }}
                >
                 ❌
                </button>
                </div>
                
              ))}
              <TextField
                autoWidth
                label="Add a filter..."
                value={newFilter}
                // onChange={(e) => setTitle(e.target.value)}
                onChange={(e) => setNewFilter(e.target.value)}
                variant="outlined"
                 sx={{
                '& .MuiInputBase-root': {
                  height: '30px', // Fixed height
                },
                '& .MuiInputBase-input': {padding: '10px 14px'},
                '& .MuiInputLabel-root': { top: '-10px' },
              }}
              />
              <button 
              onClick={handleAddFilter}
              className="filter-button"
              >Add</button>
              
            </div>
      {filteredPolicies.map(policy => (
        <OfficePolicyCard up={up} key={policy.id} id={policy.id} title={policy.title} body={policy.body} onDelete={handleDelete} imageUrls={policy.imageUrls} downloadRef={downloadRef}
        forceExpanded={allExpanded}
        ref={(el) => {
            if (el) {
              chartRefs.current[policy.id] = el;
            }
          }}
        />  
      ))}
      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px',display:'flex', justifyContent:"flex-start"  }}>
        <div style={{ marginLeft:'auto', display: 'flex', gap: '10px'}}>
        <select
         className="styled-select"
        value={downloadFormat}
        onChange={(e) => setDownloadFormat(e.target.value)}
        >
        <option value="pdf">PDF</option>
        <option value="word">Word</option>
        </select>
      <button ref={downloadRef}  onClick={() => handleDownload() } className='filter-button'>Download</button>
      </div>
      </div>
    </div>
  );
};

export default HRHandbookPage;

